import { Action } from 'redux';

import {
  StartersFetchInfoRequested,
  StartersFetchInfoSucceeded,
} from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { GetAllWorkbookStartersResult } from '../../workbook/ServerApi/requests/starters/GetAllWorkbookTemplatesRequest';
import { Starter } from '../types/StartersTypes';

export interface FetchStarterInfoSucceeded extends Action {
  starters: Starter[];
}

export interface FetchStarterInfoRequested extends Action {
  starters: Starter[];
}

export function fetchStarterInfoRequestedAction(): FetchStarterInfoRequested {
  return {
    type: StartersFetchInfoRequested,
    starters: [],
  };
}

export function fetchStartersSucceededAction(result: GetAllWorkbookStartersResult): FetchStarterInfoSucceeded {
  return {
    type: StartersFetchInfoSucceeded,
    starters: result.workbookTemplates,
  };
}

export const isFetchStartersSucceededAction = isActionFactory<FetchStarterInfoSucceeded>(StartersFetchInfoSucceeded);
export const isFetchStartersInfoRequestedAction = isActionFactory<FetchStarterInfoRequested>(StartersFetchInfoRequested);
